import { useAtomValue } from 'jotai';

import { getConfig } from '../../../config';
import { IsGraphClawHubMockEnabledAtom } from './state/atoms';

export const useGraphClawHubMockMode = (): boolean => {
	const enabled = useAtomValue(IsGraphClawHubMockEnabledAtom);
	// Direct local links can select either data source before permissions expose the toggle.
	if (
		typeof window !== 'undefined' &&
		getConfig().isLocalDev &&
		(window.location.pathname === '/graphclaw-hub/review' ||
			window.location.pathname.startsWith('/graphclaw-hub/my-inference/'))
	) {
		const params = new URLSearchParams(window.location.search);
		const preview =
			params.get('reviewSetupMock') ??
			(window.location.pathname === '/graphclaw-hub/review'
				? params.get('reviewPacketMock')
				: null);
		if (preview === 'true' || preview === 'false') return preview === 'true';
	}
	return enabled;
};
